import { render, staticRenderFns } from "./CodeBox.vue?vue&type=template&id=54c7b874&scoped=true&"
import script from "./CodeBox.vue?vue&type=script&lang=js&"
export * from "./CodeBox.vue?vue&type=script&lang=js&"
import style0 from "./CodeBox.vue?vue&type=style&index=0&id=54c7b874&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c7b874",
  null
  
)

export default component.exports